const SOL_SYMBOL = "◎";
export default SOL_SYMBOL;
